import { render, staticRenderFns } from "./AILogin.vue?vue&type=template&id=f5ccf278&scoped=true"
import script from "./AILogin.vue?vue&type=script&lang=ts"
export * from "./AILogin.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5ccf278",
  null
  
)

export default component.exports